import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row, Table } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import moment from "moment";
import { graphql } from "react-apollo";
import { withApollo } from "react-apollo";
import * as compose from 'lodash.flowright';
import Select from "react-select";
import "./_leadManagement.scss";



const ADD_LEAD_FOLLOWUP_DATA = gql`
  mutation($params: LeadFollowUpData) {
    addLeadFollowUpData(params: $params)
  }
`;

class LeadUpdateModal extends Component {
    constructor(props) {
        super();
        this.state = {
            report_details: "",
            lead_status_id: "",
            lead_status_error: "",
            calling_status_id: "",
            calling_status_error: "",
            isFolloup: "",
            isFollowupError: "",
            followup_date_time: "",
            dataClear: 0,
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            followUpData: [],
            dataClear: 1,
            loadingSpinner1: 0,
            is_submitted: false
        }
    }

    handleFormChange = (e) => {
        let name = e.target.name
        let value = e.target.value

        if (name == "report_details") {
            this.setState({
                report_details: value
            })
        }
        if (name == "lead_status") {
            this.setState({
                lead_status_id: value,
                lead_status_error: "",
                isFolloup: "",
                isFollowupError: ""
            })
        }
        if (name == "call_status") {
            this.setState({
                calling_status_id: value,
                calling_status_error: "",
            })
        }
        if (name == "is_followup") {
            this.setState({ isFolloup: value, isFollowupError: "" })
        }
        if (name == "followup_date_time") {
            this.setState({
                followup_date_time: value
            })
        }
    }

    handleSubmit = () => {
        if (this.state.lead_status_id == "" || this.state.lead_status_id == "Select Lead Status") {
            this.setState({ lead_status_error: "Please select leadstatus" })
            return ""
        }
        if (this.state.calling_status_id == "" || this.state.calling_status_id == "Select Call Status") {
            this.setState({ calling_status_error: "Please select Callstatus" })
            return ""
        }
        if (this.state.isFolloup == "" || this.state.isFolloup == "Select") {
            this.setState({ isFollowupError: "Please select" })
            return ""
        }

        let params = {
            lead_id: parseInt(this.props.stateData.rowData?.lead_id),
            lead_status_type_id: parseInt(this.state.lead_status_id),
            comments: this.state.report_details,
            calling_status_id: parseInt(this.state.calling_status_id),
            followup_time: this.state.followup_date_time != "" ? moment(this.state.followup_date_time).unix().toString() : "",
            inserted_by: parseInt(Cookies.get("id"))
        };
        this.setState({ loadingSpinner: 1 })
        console.log("params", params);

        this.addLeadFollowUpData(params).catch(error => {
            console.log("catch if error");
            console.log("error", error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            console.error(
                "ERR =>",
                error.graphQLErrors.map(x => x.message)
            );
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        });
    }

    addLeadFollowUpData = async params => {
        console.log("child");
        await this.props.addLeadFollowUpData({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addLeadFollowUpData) {
                    this.setState({
                        currentStep: 5,
                        loadingSpinner: 0,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        if (this.props.onUpdated) this.props.onUpdated();
        this.props.onHide();
    };


    getLeadFollowUpDetails = async (val) => {
        this.setState({ loadingSpinner1: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($lead_id: Int!) {
                getLeadFollowUpDetails(lead_id: $lead_id) {
                    lead_id
                    lead_name
                    lead_mobile
                    status_id
                    source_name
                    source_name
                    followUp_History {
                      comments
                      employee_id
                      employee_name
                      todayfollowUpDate
                      nextFollowUpDate
                      calling_status
                   }
                }
              }
            `,
            variables: {
                lead_id: parseInt(val),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getLeadFollowUpDetails.length > 0) {
            let data = result.data.getLeadFollowUpDetails[0].followUp_History;
            this.setState({ followUpData: data, loadingSpinner1: 0, is_submitted: true })
        } else {
            this.setState({ followUpData: [], loadingSpinner1: 0, is_submitted: true })
        }
    }


    componentDidUpdate() {

        if (this.props.show === true && this.state.dataClear == 0) {
            this.getLeadFollowUpDetails(this.props.stateData.lead_id)
            this.setState({

                report_details: "",
                lead_status_id: this.props.stateData.rowData?.lead_status_type_id,
                lead_status_error: "",
                calling_status_id: "",
                calling_status_error: "",
                followup_date_time: "",
                isFolloup: "",
                dataClear: 1,
                submitError: ""
            })
        }

        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0, followUpData: [], is_submitted: false })
        }
    }

    getCallingStatusBackgroundColor = (callingStatus) => {

        const backgroundColors = {
            'Connected': 'green',
            'Dead Cal': 'red',
            'Disconnected': 'gray',
            'Follow Up Required': 'orange',
            'Not interested': 'purple',
            'Not reachable': 'brown',
            'Switch Off': 'black',
            'Unanswered': 'blue',
            'Wrong number': 'pink',
            'Call back required': '#186F65'
        };

        return backgroundColors[callingStatus] || 'black';
    };

    render() {
        const FIN = {
            body: { background: "#f8fafc", padding: "20px 22px" },
            panel: { background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "18px 18px", height: "100%" },
            heading: { color: "#0f172a", fontWeight: 700, fontSize: 15, margin: 0, marginBottom: 14, textAlign: "center" },
            label: { fontWeight: 600, fontSize: 13, color: "#475569", marginBottom: 6 },
            input: { borderRadius: 9, border: "1px solid #e2e8f0", padding: "9px 12px", fontSize: 13, color: "#0f172a" },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 28px", fontSize: 13, fontWeight: 600, cursor: "pointer", minHeight: 42 },
        };
        return (
            <Modal
                {...this.props}
                size="lg"
                centered
                scrollable
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#0f172a" }}>Lead Update &amp; History</Modal.Title>
                </Modal.Header>
                <Modal.Body style={FIN.body}>
                <Row>
                    <Col sm={5} md={5} lg={5}>
                        <div style={FIN.panel}>
                            <h4 style={FIN.heading}>Lead Update</h4>
                            <Form className="mt-3" >
                                <Form.Row>
                                    <Form.Group as={Col} lg={12} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold" style={FIN.label}>Lead Status</Form.Label>
                                        <Form.Control as="select" name="lead_status" onChange={this.handleFormChange} value={this.state.lead_status_id} style={FIN.input} >
                                            <option >Select Lead Status</option>
                                            {this.props.stateData.getLeadStatusTypes.map(leadstatus => (
                                                <option key={leadstatus.id} value={leadstatus.id} selected={this.state.lead_status_id == leadstatus.id ? true : false}>
                                                    {leadstatus.lead_status_type}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.lead_status_error}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={12} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold" style={FIN.label}>Call Status</Form.Label>
                                        <Form.Control as="select" name="call_status" onChange={this.handleFormChange} value={this.state.calling_status_id} style={FIN.input} >
                                            <option >Select Call Status</option>
                                            {this.props.stateData.getCallStatusTypes.map(callingstatus => (
                                                <option key={callingstatus.id} value={callingstatus.id}>
                                                    {callingstatus.calling_status}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.calling_status_error}
                                        </Form.Text>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} lg={12} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold" style={FIN.label}> Is FollowUp</Form.Label>
                                        <Form.Control as="select" name="is_followup" onChange={this.handleFormChange} value={this.state.isFolloup} style={FIN.input} >
                                            <option value="">Select</option>
                                            <option value="1">Yes</option>
                                            <option value="2">No</option>
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.isFollowupError}
                                        </Form.Text>
                                    </Form.Group>
                                    {
                                        this.state.isFolloup == "1" ?
                                            <Form.Group as={Col} lg={12} md={12} sm={12} controlId="SelectBranch">
                                                <Form.Label className="font-weight-bold" style={FIN.label}>FollowUp Datetime</Form.Label>
                                                <Form.Control type="datetime-local" className="w-100" name="followup_date_time" onChange={this.handleFormChange} value={this.state.followup_date_time} style={FIN.input} />
                                            </Form.Group> : ""
                                    }

                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} lg={12} md={12} sm={12} controlId="">
                                        <p className='f-15 font-weight-bold' style={FIN.label}> Enter Remarks</p>
                                        <textarea className="form-control" style={{ ...FIN.input, minHeight: "90px" }} name="report_details" placeholder="Remarks" onChange={this.handleFormChange}></textarea>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                            <div className="text-center mt-3">
                                <button style={FIN.btnPrimary} onClick={this.handleSubmit}>
                                    {
                                        this.state.loadingSpinner == 1 ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : ""
                                    }
                                    Update</button>
                                <div>
                                    {this.state.currentStep == 5 ? (
                                        <p style={{ color: "#16a34a", marginTop: "6px", fontWeight: 600, fontSize: 13 }}>Status Updated Successfully</p>
                                    ) : (
                                        <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                            {this.state.submitError}
                                        </Form.Text>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={7} md={7} lg={7} className="mt-3 mt-sm-0">
                        <div style={FIN.panel}>
                            <h4 style={FIN.heading}>Lead History</h4>
                            <div style={{
                                width: '100%',
                                height: '420px',
                                overflowY: 'auto',
                                overflowX: 'hidden'
                            }}>
                                {
                                    this.state.followUpData.length > 0 ? (

                                        this.state.followUpData.map((item, index) => {
                                            let todayfollowUpDate = moment.unix(item.todayfollowUpDate).format("DD MMM YYYY h:mm a");
                                            // let followupDate = moment.unix(item.nextFollowUpDate).format("DD MMM YYYY h:mm a");
                                            return (
                                                <div className="mb-2">

                                                    <Row>
                                                        <Col sm={8} md={8} lg={8}>
                                                            <p className="text-muted" style={{ fontSize: "12px", fontFamily: "Helvetica", fontWeight: "600", }}>{todayfollowUpDate} followed by {item.employee_name}</p>
                                                        </Col>
                                                        <Col sm={4} md={4} lg={4}>
                                                            <p className="text-center" style={{ color: "#000000", padding: "3px 5px", borderRadius: '19px', backgroundColor: '#dee2e6' }}>{item.calling_status}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <Card className="border-0">
                                                                <Card.Body>
                                                                    {item.comments || '-'}
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                    </Row>

                                                    <hr />
                                                </div>

                                            )
                                        })
                                    ) : (
                                        this.state.is_submitted == true && this.state.followUpData.length == 0 ? (
                                            <div className="mt-2 d-flex justify-content-center align-items-center">
                                                <p>No Data Found</p>
                                            </div>
                                        ) : (
                                            this.state.loadingSpinner1 == 1 ? (
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            ) : ("")
                                        )
                                    )
                                }
                            </div>
                        </div>

                    </Col>
                </Row>
                </Modal.Body>

            </Modal>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_LEAD_FOLLOWUP_DATA, {
        name: "addLeadFollowUpData"
    })
)(LeadUpdateModal)));


